import { createAction, props } from '@ngrx/store';

import { ILegalVersionUpdate, IResultLegal, IResultLegalVersion, IResultUpdateLegal } from '../../shared/models/Legales';

/**
 * * Acepta los legales
 */
export const agreeLegals = createAction(
    '[AgreeLegals] Agree Legals documents'
);

export const successAgreeLegals = createAction(
    '[AgreeLegals] Agree Legals documents Success',
    props<IResultUpdateLegal>()
);

export const errroAgreeLegals = createAction(
    '[AgreeLegals] Agree Legals documents Error',
    props<{ payload: Error }>()
);

export const agreeLegalsClear = createAction(
    '[AgreeLegalsClear] Agree Legals documents Clear'
);

/**
 * * Consulta los legales
 */
export const getLegals = createAction(
    '[GetLegals] Get Legals documents',
    props<{ api: string; }>()
);

export const successGetLegals = createAction(
    '[GetLegals] Get Legals documents Success',
    props<IResultLegal>()
);

export const errroGetLegals = createAction(
    '[GetLegals] Get Legals documents Error',
    props<{ payload: Error }>()
);

export const GetLegalsClear = createAction(
    '[GetLegalsClear] Get Legals documents Clear'
);

/**
 * * Obtiene versión legal por ID
 */
export const getLegalVersion = createAction(
    '[GetLegalVersion] Get Legal Version',
    props<{ ID_LegalTipo: number | null; }>()
);

export const successGetLegalVersion = createAction(
    '[GetLegalVersion] Get Legal Version Success',
    props<IResultLegalVersion>()
);

export const errorGetLegalVersion = createAction(
    '[GetLegalVersion] Get Legal Version Error',
    props<{ payload: Error }>()
);

export const getLegalVersionClear = createAction(
    '[GetLegalVersionClear] Get Legal Version Clear'
);

/**
 * * Actualiza versión legal
 */
export const updateLegalVersion = createAction(
    '[UpdateLegalVersion] Update Legal Version',
    props<{ legales: ILegalVersionUpdate[]; }>()
);

export const successUpdateLegalVersion = createAction(
    '[UpdateLegalVersion] Update Legal Version Success',
    props<IResultLegalVersion>()
);

export const errorUpdateLegalVersion = createAction(
    '[UpdateLegalVersion] Update Legal Version Error',
    props<{ payload: Error }>()
);
